import React, { useState } from "react";
import { useAuth } from "../lib/auth";
import { useNavigate, Link } from "react-router-dom";
import { toast, Toaster } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) { toast.success("Bentornato."); nav("/admin"); }
    else toast.error(r.error);
  };
  return (
    <div className="min-h-screen paper-bg flex" data-testid="login-page">
      <Toaster position="top-right" richColors />
      <div className="hidden md:flex md:w-1/2 border-r border-[#E6E4E0] p-16 flex-col justify-between paper-alt-bg">
        <Link to="/" className="leading-none">
          <div className="font-serif text-xl text-[#7D2E3F] tracking-[0.14em]">PRONTO ALLA VENDITA</div>
          <div className="label-uppercase mt-1 text-[#5C5657]">by RX CASA</div>
        </Link>
        <div>
          <div className="label-uppercase mb-4">Area riservata</div>
          <h1 className="font-serif text-5xl leading-tight max-w-md">Gestionale Interno</h1>
          <p className="text-[#5C5657] mt-6 max-w-md">Anagrafiche, fascicoli, attribuzione esiti e pubblicazione in Galleria Pronto alla Vendita.</p>
        </div>
        <div className="text-xs text-[#5C5657]">Uso riservato allo staff RX CASA. Ogni azione è tracciata nell'audit log.</div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md">
          <div className="label-uppercase mb-4">Accedi</div>
          <h2 className="font-serif text-4xl mb-2">Accedi al gestionale</h2>
          <p className="text-sm text-[#5C5657] mb-10">Uso riservato allo staff RX CASA.</p>
          <div className="space-y-6">
            <div>
              <label className="label-uppercase">Email</label>
              <input required type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="editorial-input" autoFocus />
            </div>
            <div>
              <label className="label-uppercase">Password</label>
              <input required type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="editorial-input" />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit" className="btn-primary w-full">{loading ? "Accesso…" : "Accedi"}</button>
            <Link to="/" className="block text-xs text-center text-[#5C5657] hover:text-[#7D2E3F]">← Torna al sito pubblico</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
